import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { useSignInMutation } from '@/entities/session'
import { errorMessage } from '@/shared/api'
import { Button } from '@/shared/ui/button'
import { Field, Input } from '@/shared/ui/field'

/**
 * Вход. Самозаписи нет: сотрудника заводит команда и передаёт пароль лично
 * (`RegisterEmployee § Notes`), поэтому здесь нет ни регистрации, ни
 * восстановления. Ошибка одна на все случаи — иначе состав команды можно
 * перебрать по разным ответам.
 */
export function SignInForm() {
  const navigate = useNavigate()
  const signIn = useSignInMutation()
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    signIn.mutate(
      { login: login.trim(), password },
      { onSuccess: () => void navigate({ to: '/schedule' }) },
    )
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-sm flex-col gap-5">
      <Field label="Логин">
        {(props) => (
          <Input
            {...props}
            value={login}
            autoComplete="username"
            onChange={(e) => setLogin(e.target.value)}
          />
        )}
      </Field>
      <Field label="Пароль">
        {(props) => (
          <Input
            {...props}
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        )}
      </Field>
      {signIn.isError && (
        <p role="alert" className="text-sm text-accent">
          {errorMessage(signIn.error)}
        </p>
      )}
      <Button type="submit" disabled={signIn.isPending || !login || !password}>
        {signIn.isPending ? 'Входим…' : 'Войти'}
      </Button>
    </form>
  )
}
